<mat-toolbar class="panel-toolbar">
  <button mat-raised-button color="primary" (click)="onSave()" [disabled]="form.invalid">
    {{ label('Guardar', 'Guardar') }}
  </button>
  <span class="spacer"></span>
  <button mat-icon-button (click)="onCancel()" aria-label="Cerrar">
  <mat-icon>close</mat-icon>
</button>
</mat-toolbar>

<form [formGroup]="form" class="form-body">
  <div class="panel-container">
            <mat-form-field appearance="outline">
      <mat-label>{{ label('Codigo', 'Código') }}</mat-label>
      <input matInput formControlName="Codigo" readonly />
            </mat-form-field>

            <mat-form-field appearance="outline">
      <mat-label>{{ label('Nombre', 'Nombre') }}</mat-label>
      <input matInput formControlName="Nombre" placeholder="{{ label('Nombre', 'Nombre') }}" />
      <mat-error *ngIf="f['Nombre'].hasError('required')">
        {{ label('SeRequiereNombre', 'Se requiere nombre') }}
              </mat-error>
            </mat-form-field>
          </div>

  <div class="panel-container">
            <mat-form-field appearance="outline">
      <mat-label>{{ label('Descripcion', 'Descripción') }}</mat-label>
      <input matInput formControlName="Descripcion" placeholder="{{ label('Descripcion', 'Descripción') }}" />
            </mat-form-field>

            <mat-form-field appearance="outline">
      <mat-label>{{ label('NivelEntrada', 'Nivel entrada') }}</mat-label>
              <mat-select formControlName="NivelEntrada">
        <mat-option *ngFor="let n of nivelesEntrada" [value]="n.id">{{ n.label }}</mat-option>
              </mat-select>
            </mat-form-field>
        </div>

  <div class="panel-container">
    <mat-card>
      <div class="section-title">{{ label('Comprobaciones', 'Comprobaciones') }}</div>
      <div class="checks-grid">
        <mat-slide-toggle formControlName="CompHoraria">{{ label('Horario', 'Horario') }}</mat-slide-toggle>
        <mat-slide-toggle formControlName="CompDiaria">{{ label('Diario', 'Diario') }}</mat-slide-toggle>
        <mat-slide-toggle formControlName="CompIntervalo">{{ label('Intervalo', 'Intervalo') }}</mat-slide-toggle>
        <!-- COMENTADO TEMPORARIAMENTE - SERÁ IMPLEMENTADO NO FUTURO -->
        <!-- <mat-slide-toggle formControlName="CompCalendario">{{ label('Calendario', 'Calendario') }}</mat-slide-toggle> -->
        <mat-slide-toggle formControlName="DenegarAcceso">{{ label('DenegarAcceso', 'Denegar acceso') }}</mat-slide-toggle>
        <mat-slide-toggle formControlName="PermisoSinFecha">{{ label('SinFecha', 'Sin fecha') }}</mat-slide-toggle>
        <mat-slide-toggle formControlName="CompDiaSemana">{{ label('DiaSemana', 'Día semana') }}</mat-slide-toggle>
        <mat-slide-toggle formControlName="CompPasoPrevio">{{ label('PasoPrevio', 'Paso previo') }}</mat-slide-toggle>
        <!-- COMENTADO TEMPORARIAMENTE - SERÁ IMPLEMENTADO NO FUTURO -->
        <!-- <mat-slide-toggle formControlName="CompCalendHorario">{{ label('CalendarioHorario', 'Calendario horario') }}</mat-slide-toggle> -->
        </div>
    </mat-card>

    <mat-card [class.error-border]="shouldShowDiasSemanaError">
      <div class="section-title">{{ label('DiasConDisponibilidad', 'Días con disponibilidad') }}</div>
          <div class="dias-grid">
            <mat-slide-toggle
          *ngFor="let d of diasSemana"
          [checked]="hasDia(d.id)"
          (change)="onDiaToggle(d.id, $event.checked)"
          [disabled]="!form.value.CompDiaSemana"
            >
          {{ d.value }}
            </mat-slide-toggle>
          </div>
      <mat-hint class="error-text" *ngIf="shouldShowDiasSemanaError">
        {{ label('SeleccioneAlMenosUnDia', 'Seleccione al menos un día') }}
      </mat-hint>
      </mat-card>
    </div>

  <div class="intervalo-row" [class.hidden]="!form.value.CompIntervalo">
    <mat-form-field appearance="outline">
      <mat-label>{{ label('DiasIntervaloDesde', 'Días intervalo desde') }}</mat-label>
      <input matInput type="number" formControlName="DiasIntervaloDesde" />
    </mat-form-field>

            <mat-form-field appearance="outline">
      <mat-label>{{ label('DiasIntervaloHasta', 'Días intervalo hasta') }}</mat-label>
      <input matInput type="number" formControlName="DiasIntervalo" />
            </mat-form-field>
          </div>

  <div class="paso-previo-row" [class.hidden]="!form.value.CompPasoPrevio">
    <mat-form-field appearance="outline">
      <mat-label>{{ label('NumPasosPreviosDiarios', 'Número de pasos previos diarios') }}</mat-label>
      <input matInput type="number" formControlName="NumPasosPreviosDiarios" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ label('NumPasosPrevios', 'Número de pasos previos totales') }}</mat-label>
      <input matInput type="number" formControlName="NumPasosPrevios" />
    </mat-form-field>
          </div>

  <!-- COMENTADO TEMPORARIAMENTE - SERÁ IMPLEMENTADO NO FUTURO -->
  <!-- <div class="error-text" *ngIf="calendarioRequiredError">
    {{ label('CalendarioRequerido', 'Debe añadir al menos un rango en el calendario') }}
  </div>
  <mat-expansion-panel
    #calendarioPanel="matExpansionPanel"
    class="exp-panel"
    *ngIf="panelCalendarioEnabled"
    [expanded]="calendarioPanelExpanded"
    [hideToggle]="true"
  >
    <mat-expansion-panel-header
      [class.panel-clickable]="calendarioDS.data.length > 0"
      (click)="calendarioDS.data.length > 0 ? togglePanel(calendarioPanel, 'calendario', $event) : null"
    >
      <div class="header-content">
        <span class="panel-title">{{ label('Calendario', 'Calendario') }}</span>
        <div class="panel-actions">
          <button
            mat-icon-button
            (click)="addCalendarioRow(); $event.stopPropagation()"
            [disabled]="!panelCalendarioEnabled"
            aria-label="Añadir rango calendario"
          >
            <mat-icon>add</mat-icon>
          </button>
          <button
            *ngIf="calendarioDS.data.length"
            mat-icon-button
            (click)="togglePanel(calendarioPanel, 'calendario', $event)"
            aria-label="Contraer calendario"
          >
            <mat-icon>{{ calendarioPanelExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
        </div>
      </div>
    </mat-expansion-panel-header>

    <div class="mat-elevation-z2 table-wrapper">
      <table mat-table [dataSource]="calendarioDS" class="full-width">
        <ng-container matColumnDef="Acciones">
          <th mat-header-cell *matHeaderCellDef class="table-header">{{ label('Acciones', 'Acciones') }}</th>
          <td mat-cell *matCellDef="let row; let i = index">
            <button mat-icon-button color="warn" (click)="removeCalendarioRow(i)">
              <mat-icon>delete</mat-icon>
                  </button>
                </td>
        </ng-container>

        <ng-container matColumnDef="FechaInicio">
          <th mat-header-cell *matHeaderCellDef class="table-header">{{ label('FechaAccesoInicio', 'Fecha acceso inicio') }}</th>
          <td mat-cell *matCellDef="let row">
            <input matInput type="date" [(ngModel)]="row.FechaAcceso" [ngModelOptions]="{ standalone: true }" />
                </td>
        </ng-container>

        <ng-container matColumnDef="FechaFin">
          <th mat-header-cell *matHeaderCellDef class="table-header">{{ label('FechaAccesoFin', 'Fecha acceso fin') }}</th>
          <td mat-cell *matCellDef="let row">
            <input matInput type="date" [(ngModel)]="row.FechaAccesoFin" [ngModelOptions]="{ standalone: true }" />
                </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnasCalendario"></tr>
        <tr mat-row *matRowDef="let row; columns: columnasCalendario; trackBy: trackCal"></tr>
          </table>
        </div>
  </mat-expansion-panel> -->

  <!-- COMENTADO TEMPORARIAMENTE - SERÁ IMPLEMENTADO NO FUTURO -->
  <!-- <div class="error-text" *ngIf="calendarioHorarioRequiredError">
    {{ label('CalendarioHorarioRequerido', 'Debe añadir al menos un rango horario') }}
        </div>
  <mat-expansion-panel
    #calendarioHorarioPanel="matExpansionPanel"
    class="exp-panel"
    *ngIf="panelCalendarioHorarioEnabled"
    [expanded]="calendarioHorarioPanelExpanded"
    [hideToggle]="true"
  >
    <mat-expansion-panel-header
      [class.panel-clickable]="calendarioHorarioDS.data.length > 0"
      (click)="calendarioHorarioDS.data.length > 0 ? togglePanel(calendarioHorarioPanel, 'horario', $event) : null"
    >
      <div class="header-content">
        <span class="panel-title">{{ label('CalendarioHorario', 'Calendario horario') }}</span>
        <div class="panel-actions">
          <button
            mat-icon-button
            (click)="addCalendarioHorarioRow(); $event.stopPropagation()"
            [disabled]="!panelCalendarioHorarioEnabled"
            aria-label="Añadir rango horario"
          >
            <mat-icon>add</mat-icon>
          </button>
          <button
            *ngIf="calendarioHorarioDS.data.length"
            mat-icon-button
            (click)="togglePanel(calendarioHorarioPanel, 'horario', $event)"
            aria-label="Contraer calendario horario"
          >
            <mat-icon>{{ calendarioHorarioPanelExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
        </div>
      </div>
    </mat-expansion-panel-header>

    <div class="mat-elevation-z2 table-wrapper">
      <table mat-table [dataSource]="calendarioHorarioDS" class="full-width">
        <ng-container matColumnDef="Acciones">
          <th mat-header-cell *matHeaderCellDef class="table-header">{{ label('Acciones', 'Acciones') }}</th>
          <td mat-cell *matCellDef="let row; let i = index">
            <button mat-icon-button color="warn" (click)="removeCalendarioHorarioRow(i)">
              <mat-icon>delete</mat-icon>
                  </button>
                </td>
        </ng-container>

        <ng-container matColumnDef="HoraInicio">
          <th mat-header-cell *matHeaderCellDef class="table-header">{{ label('HoraAccesoInicio', 'Hora acceso inicio') }}</th>
          <td mat-cell *matCellDef="let row">
            <input matInput type="time" [(ngModel)]="row.FechaAcceso" [ngModelOptions]="{ standalone: true }" />
                </td>
        </ng-container>

        <ng-container matColumnDef="HoraFin">
          <th mat-header-cell *matHeaderCellDef class="table-header">{{ label('HoraAccesoFin', 'Hora acceso fin') }}</th>
          <td mat-cell *matCellDef="let row">
            <input matInput type="time" [(ngModel)]="row.FechaAccesoFin" [ngModelOptions]="{ standalone: true }" />
                </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnasCalendarioHorario"></tr>
        <tr mat-row *matRowDef="let row; columns: columnasCalendarioHorario; trackBy: trackCalH"></tr>
          </table>
        </div>
  </mat-expansion-panel> -->
  </form>

